import React from 'react';
import { withRouter } from 'react-router-dom';
import { range, isEmpty, get } from 'lodash';
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  FormLabel,
} from '@mui/material';
import { isOnMobile } from '../../../lib/utils';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function BasePendingRunModal({
  openPendingRunModal,
  currentRun,
  setCurrentRun,
  handleClose,
  handleSaveRun,
  assigneeOptions,
  pendingRunAssignees,
  setPendingRunAssignees,
  marketVanCapacity,
  styles,
}) {
  const theme = useTheme();
  let runVanCount;
  if (currentRun?.deployCount) {
    runVanCount = Math.ceil(currentRun.deployCount / marketVanCapacity);
  } else if (currentRun?.vanCount) {
    runVanCount = currentRun.vanCount;
  } else runVanCount = 1;
  const countArray = range(runVanCount);
  const modalText = `Clicking submit will create ${runVanCount} run(s) with Pending status. You may assign an OA to the run(s) now. The OA will be able to start the run(s) in around 5 minutes.`;

  const handleSubmitPendingRun = () => {
    if (!isEmpty(pendingRunAssignees)) {
      // eslint-disable-next-line no-param-reassign
      currentRun.vanAssignees = pendingRunAssignees;
      setCurrentRun(currentRun);
    }
    handleSaveRun(currentRun);
    handleClose();
  };

  const handleChange = (event) => {
    const fieldName = event.target.name;
    const value = event.target.value;
    const newState = {
      ...pendingRunAssignees,
      [fieldName]: value,
    };
    setPendingRunAssignees(newState);
  };

  const DisplayWranglerOptions = () => countArray.map((idx) => (
    <Grid item xs={12} sx={{ marginTop: 2 }} key={idx}>
      <FormControl sx={{ m: 1, minWidth: 300 }}>
        <FormLabel style={styles.runTypeLabel}>Select an OA(s)</FormLabel>
        <Select
          fullWidth
          multiple
          displayEmpty
          value={get(pendingRunAssignees, `${idx}`, [])}
          name={`${idx}`}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (isEmpty(pendingRunAssignees)
            || isEmpty(get(pendingRunAssignees, `${idx}`, []))) {
              return 'Assign Later';
            }
            const selectedAssignees = assigneeOptions.filter(
              (assignee) => selected.includes(assignee.value),
            ).map(
              (assignee) => assignee.label,
            );
            return selectedAssignees.join(', ');
          }}
          MenuProps={MenuProps}
          onChange={handleChange}
          sx={{ height: 50 }}
        >
          {assigneeOptions.map((option) => (
            <MenuItem
              key={option.label}
              value={option.value}
              style={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  ));

  return (
    <Dialog
      open={openPendingRunModal}
      onClose={handleClose}
      maxWidth={isOnMobile() ? 'sm' : 'lg'}
      disableEnforceFocus
    >
      <DialogTitle style={styles.flexRow}>
        <Typography style={styles.header}>Assign the run now?</Typography>
      </DialogTitle>
      <DialogContent sx={{ pb: 5 }}>
        <Grid style={styles.flexRow}>
          <Grid item container style={styles.content} xs={10}>
            <Grid sx={{ pb: 2 }}>
              <Typography variant="subtitle1">
                {modalText}
              </Typography>
            </Grid>
            <DisplayWranglerOptions />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          style={styles.button}
        >
          Back
        </Button>
        <Button
          onClick={handleSubmitPendingRun}
          color="primary"
          variant="contained"
          style={styles.button}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const PendingRunModal = withRouter((BasePendingRunModal));
export { BasePendingRunModal, PendingRunModal };
